var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.875 10.0515C21.375 10.9176 21.375 13.0826 19.875 13.9487L9.375 20.0108C7.875 20.8769 6 19.7943 6 18.0623L6 5.93793C6 4.20588 7.875 3.12334 9.375 3.98937L19.875 10.0515ZM19.125 12.6496C19.625 12.3609 19.625 11.6393 19.125 11.3506L8.625 5.28841C8.125 4.99973 7.5 5.36058 7.5 5.93793L7.5 18.0623C7.5 18.6396 8.125 19.0005 8.625 18.7118L19.125 12.6496Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay24Line);
export default __webpack_public_path__ + "static/media/Play-24-line.a6dc96da1764e33e9357aac5458d10fc.svg";
export { ForwardRef as ReactComponent };